import React, { useState } from 'react'
import { Container } from 'react-bootstrap';
import { Form, Schema } from 'rsuite';
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons';
import JournalPrivacyCard from './JournalPrivacyCard';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import privacyService from '../../../../../../services/Public/Renewal/EI/privacy.service';
import Swal from 'sweetalert2';
import renewalService from '../../../../../../services/Public/Renewal/EI/eiRenewal.service';
import Information from '../../../../../Shared/Card/Information';
import { GetRenewalInformationContent } from '../../../../../Shared/InformationContent/EiInformation';
import Issues from '../../../../../Shared/Card/Issues';

function Privacy() {
    const [sectionData, setSectionData] = useState({});
    const routes = useSelector(x => x.currentRoutes);
    const renewalId = useSelector(x => x.currentApplicationId);
    const push = useNavigate();
    const sectionId = 6;
    const entityId = useSelector(x => x.userInfo.EntityId)

    const { StringType, BooleanType } = Schema.Types;
    const model = Schema.Model({
        emailPhonePrivacy: BooleanType().isRequired('This field is required.'),
        receiveMethod: StringType().isRequired('This field is required.')
    });

    const [formData, updateFormData] = useState({
        id: 0,
        entityId: entityId,
        emailPhonePrivacy: null,
        journalEmail: null,
        journalMail: null,
        journalDoNotSend: null,
        userCrte: "",
        dateCrte: new Date(),
        deleted: false,
        receiveMethod: "",
        emailAddress: ""
    });

    useEffect(() => {
        renewalService.eiGetSection(renewalId, sectionId).then((data) => {
            setSectionData(data.data)
            privacyService.getPrivacyData().then((response) => {
                if (response.data) {
                    updateFormData({
                        ...response.data,
                        receiveMethod: response.data.journalEmail
                            ? "email"
                            : response.data.journalDoNotSend
                                ? "none"
                                : null
                    })
                }
            })
        })
    }, [])

    const handleSubmit = () => {
        var dataToTransmit = {
            ...formData,
            journalEmail: formData.receiveMethod === "email" ? true : null,
            journalMail: formData.receiveMethod === "mail" ? true : null,
            journalDoNotSend: formData.receiveMethod === "none" ? true : null,
        }

        privacyService.postPrivacyData(dataToTransmit).then((response) => {
            if (response.data.id) {
                nextSectionNavigation();
            }
        })
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div className="eiRenewalPrivacy">
            <Container fluid>
                <strong>Engineer Intern Renewal</strong>
                <h4 className="mb-3">Journal & Privacy Option</h4>
                <Information content={GetRenewalInformationContent("privacy")} />
                <br />
                <Form model={model} readOnly={!sectionData.isUserEditable} onSubmit={handleSubmit} onChange={updateFormData} fluid formValue={formData}>
                    <JournalPrivacyCard emailAddress={formData.emailAddress} />
                    <br />
                    <Issues isUserEditable={true} type={3} sectionId={sectionData.id} />
                    <FormActionButtons nextSectionCallback={nextSectionNavigation} isReadOnly={!sectionData.isUserEditable} backToSectionLink="/individual/eirenewal/sections" />
                </Form>
            </Container>
        </div>
    )
}
export default Privacy;